import { combineReducers } from 'redux';
import asins from './asins';

export const asinFinderReducers = combineReducers({
  asins,
});
